import { Box, FormHelperText, InputAdornment, TextField, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ILabeledInputProps {
  label: string;
  id: string;
  type: string;
  value?: string;
  placeholder?: string;
  endIcon?: React.ReactNode;
  handleChange?: (_event: React.ChangeEvent<HTMLInputElement>) => void;
  width?: string;
  required?: boolean;
  name?: string;
  onBlur?: (_event: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
}
const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    height: '43px',
    marginTop: '3px',
    marginBottom: '4px',
    '& fieldset': {
      padding: '12px',
      border: 'none',
      color: theme.palette.primary.main,
      backgroundColor: 'rgba(171, 209, 198, 0.20)',
    },
  },
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    bottom: '0px',
    right: '0px',
  },
}));

const LabeledInput = ({
  label,
  id,
  type,
  placeholder,
  endIcon,
  handleChange,
  value,
  width,
  required,
  name,
  onBlur,
  error,
}: ILabeledInputProps) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column" justifyContent="center">
      <Box gap="5px">
        <Typography variant="meta" color="primary">
          {label} {required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
        <StyledTextField
          id={id}
          label=""
          value={value}
          placeholder={placeholder}
          type={type}
          variant="outlined"
          onChange={handleChange}
          InputProps={{
            endAdornment: endIcon ? (
              <InputAdornment position="end">{endIcon}</InputAdornment>
            ) : null,
          }}
          style={{ width }}
          required={required}
          name={name}
          onBlur={onBlur}
        />
      </Box>
      {error && (
        <FormHelperText sx={{ color: 'red', marginTop: '-8px' }}>{t(error)}</FormHelperText>
      )}
    </Box>
  );
};

LabeledInput.defaultProps = {
  placeholder: '',
  endIcon: null,
  value: '',
  handleChange: () => {},
  width: '415px',
  required: false,
};

export default LabeledInput;
